"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EmailInput = void 0;
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _reactHookForm = require("react-hook-form");
var _constants = require("../../../../constants");
var _hooks = require("../../../../hooks");
var _constants2 = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const EmailInput = () => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    register
  } = (0, _reactHookForm.useFormContext)();
  const {
    errors
  } = (0, _reactHookForm.useFormState)({
    name: 'email'
  });
  const email = (0, _reactHookForm.useWatch)({
    name: 'email'
  });
  const {
    translations
  } = (0, _hooks.useTranslations)();
  const inputProps = (0, _react.useMemo)(() => ({
    endAdornment: null,
    [_constants.DATA_TEST_ID]: getTestId(_constants2.EMAIL_INPUT)
  }), [getTestId]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.StyledInput, {
    ...register('email'),
    required: true,
    fullWidth: true,
    id: "email",
    type: "email",
    label: translations.email,
    margin: "normal",
    variant: "standard",
    InputLabelProps: _constants2.inputLabelProps,
    InputProps: inputProps,
    value: email,
    error: !!errors.email
  });
};
exports.EmailInput = EmailInput;
